import { render, staticRenderFns } from "./EditTestConfig.vue?vue&type=template&id=453900c2"
import script from "./EditTestConfig.vue?vue&type=script&lang=js"
export * from "./EditTestConfig.vue?vue&type=script&lang=js"
import style0 from "./EditTestConfig.vue?vue&type=style&index=0&id=453900c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports